import { useContext } from "react";
import { AuthContext } from "../providers/auth";

export const useAuth = () => {
    // Используйте ! для утверждения, что контекст всегда инициализирован
    const context = useContext(AuthContext)!; 
    return context;
};